import React, { Component } from 'react';

export default class Rupee extends Component {
  render () {
    const { value, className } = this.props;
    if (typeof value === 'undefined') {
      return (
        <i className={`icon icon-inr ${className}`} />
      );
    }

    return (
      <span className={className}>
        <i className="icon icon-inr" />
        {value}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/Rupee.js